/**
 * Owner: Masa Bayu
 * File: commerce-security.ts
 * Date:Time: 2026-09-15 22:25
 * Description: T3 commerce security — E1 cart/checkout + E2 payment ≠ Library/Reader.
 */
export const QXREAD_T3_E1_PROHIBITED = [
    'QXRead → charge Payment from Cart',
    'QXRead → mint Entitlement from Cart',
    'QXRead → trust client seller price as authority',
    'QXRead → open Library from Checkout',
    'QXRead → execute Reader from Checkout',
    'QXRead → mutate QXP publication truth',
];
export const QXREAD_T3_E2_PROHIBITED = [
    'QXRead → treat Payment success as Reader access',
    'QXRead → open Library from Payment success',
    'QXRead → launch QXReader from Payment success',
    'QXRead → mint duplicate Entitlement from duplicate callback',
    'QXRead → confirm Order without succeeded Payment',
    'QXRead → issue Entitlement for failed Payment',
    'QXRead → issue Entitlement for cancelled Payment',
    'QXRead → mutate QXP from Payment reconciliation',
];
export const QXREAD_T3_E1_SECURITY = Object.freeze({
    cartDoesNotChargePayment: true,
    cartDoesNotMintEntitlement: true,
    clientPriceIsNotAuthority: true,
    checkoutDoesNotOpenLibrary: true,
    checkoutDoesNotLaunchReader: true,
    commerceDoesNotMutateQxp: true,
    paymentSuccessIsNotReaderAccess: true,
});
export const QXREAD_T3_E2_SECURITY = Object.freeze({
    paymentSuccessIsNotReaderAccess: true,
    paymentSuccessDoesNotOpenLibrary: true,
    paymentSuccessDoesNotLaunchReader: true,
    duplicateCallbackDoesNotDuplicateEntitlement: true,
    failedPaymentDoesNotIssueEntitlement: true,
    cancelledPaymentDoesNotIssueEntitlement: true,
    orderConfirmRequiresSucceededPayment: true,
    entitlementIssuanceIsServerBoundary: true,
    paymentDoesNotMutateQxp: true,
    sameAttemptIsIdempotent: true,
});
export function isT3E1ProhibitedOperation(operation) {
    return QXREAD_T3_E1_PROHIBITED.includes(operation);
}
export function isT3E2ProhibitedOperation(operation) {
    return QXREAD_T3_E2_PROHIBITED.includes(operation);
}
export function assertT3E1SecurityIntact(overrides = {}) {
    for (const key of Object.keys(QXREAD_T3_E1_SECURITY)) {
        const expected = QXREAD_T3_E1_SECURITY[key];
        if (Object.prototype.hasOwnProperty.call(overrides, key) && overrides[key] !== expected) {
            throw new Error(`QXRead T3-E1 security violated: ${key}`);
        }
    }
    return QXREAD_T3_E1_SECURITY;
}
export function assertT3E2SecurityIntact(overrides = {}) {
    for (const key of Object.keys(QXREAD_T3_E2_SECURITY)) {
        const expected = QXREAD_T3_E2_SECURITY[key];
        if (Object.prototype.hasOwnProperty.call(overrides, key) && overrides[key] !== expected) {
            throw new Error(`QXRead T3-E2 security violated: ${key}`);
        }
    }
    return QXREAD_T3_E2_SECURITY;
}
//# sourceMappingURL=commerce-security.js.map